import { Link } from 'react-router'
import {
  getOwnerIdFromSettings,
  MoonStarsIcon,
  Mtds,
  NewspaperIcon,
  SunDimIcon,
  AppLayout,
  ScreenHeader,
  TreeStructureIcon,
  useAuth,
  useAvdeling,
  useGetOwnerNameQuery,
  UserIcon,
  useTheme
} from 'prove-common'
import { BuildInfo } from '../../components/build-info/BuildInfo'
import { BetaFeaturesSection } from '../../components/beta-features-section/BetaFeaturesSection'
import { BetaFeature } from '../../hooks/useBetaFeature'
import { AppVersionMeta } from '../../hooks/useAutoUpdater'

type SettingsScreenProps = {
  versionMeta: AppVersionMeta
  topBar?: React.ReactNode
  sidebar?: React.ReactNode
  useMobileBar?: boolean
  betaFeatures?: BetaFeature[]
}

export const SettingsScreen = ({
  versionMeta,
  topBar,
  sidebar,
  useMobileBar,
  betaFeatures = []
}: SettingsScreenProps) => {
  const settings = useAvdeling()
  const ownerIdFilter = getOwnerIdFromSettings(settings.get)
  const { theme } = useTheme()
  const { accountName, logout } = useAuth()
  const { data: ownerName } = useGetOwnerNameQuery(ownerIdFilter)
  let themeLabel = 'Systemvalg'
  if (theme === 'light') {
    themeLabel = 'Lys'
  } else if (theme === 'dark') {
    themeLabel = 'Mørk'
  }

  return (
    <AppLayout sidebar={sidebar} topBar={topBar} useMobileBar={useMobileBar}>
      <ScreenHeader
        title='Innstillinger'
        description={
          <p>Her kan du endre innstillinger for å tilpasse din bruk.</p>
        }
      />
      <Mtds.Grid>
        <Mtds.Card
          as={Mtds.Flex}
          data-align='center'
          data-justify='space-between'
        >
          <Mtds.Info data-variant='circle'>
            <UserIcon />
            <strong>Brukernavn</strong>
            <span>{accountName ?? ''}</span>
          </Mtds.Info>
          <Mtds.Button data-variant='secondary' onClick={logout}>
            Logg ut
          </Mtds.Button>
        </Mtds.Card>
        <Mtds.Card as={Link} to='/settings/select-division'>
          <Mtds.Info data-variant='circle'>
            <TreeStructureIcon />
            <strong>Tilhørighet</strong>
            <span>{ownerName?.name?.replace(/./, (m) => m.toUpperCase())}</span>
          </Mtds.Info>
        </Mtds.Card>
        <Mtds.Card as={Link} to='/settings/select-theme'>
          <Mtds.Info data-variant='circle'>
            {theme === 'dark' ? <MoonStarsIcon /> : <SunDimIcon />}
            <strong>Tema</strong>
            <span>{themeLabel}</span>
          </Mtds.Info>
        </Mtds.Card>
        <Mtds.Card as={Link} to='/newslist'>
          <Mtds.Info data-variant='circle'>
            <NewspaperIcon />
            <strong>Nyheter</strong>
            <span>Her kan du se nyheter som har blitt delt tidligere</span>
          </Mtds.Info>
        </Mtds.Card>
        <BetaFeaturesSection features={betaFeatures} />
        <BuildInfo versionMeta={versionMeta} />
      </Mtds.Grid>
    </AppLayout>
  )
}
